<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Controleren"
      @next-step="$router.push({ name: 'copyOrderConfirm' })"
      @prev-step="$router.push({ name: 'copyOrderDeliver' })"
    ></next-prev-menu>
    <invoice
      :orderDetails="orderDetails"
      :shop="shop"
      @updateOrder="updateOrder"
      @updateProject="updateProject"
    ></invoice>
  </div>
</template>

<script>
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import Invoice from '@/components/Invoice.vue'
import { mapStores } from 'pinia'
import { useCopyOrderStore } from '@/features/copyOrder/CopyOrder.store'

export default {
  data() {
    return {}
  },
  components: {
    NextPrevMenu,
    Invoice
  },
  methods: {
    updateOrder(val) {
      this.copyOrderStore.updateOrderDetails(val[0], val[1])
    },
    updateProject(project) {
      this.copyOrderStore.updateProject({
        name: project.name || '',
        id: project.id || 0
      })
    }
  },
  computed: {
    ...mapStores(useCopyOrderStore),
    orderDetails() {
      return this.copyOrderStore.orderDetails
    },
    shop() {
      return this.copyOrderStore.shop
    },
    custom: (state) => state.theme.customFields
  },
  created() {}
}
</script>
